const state = {
    barcode_settings: [],
};

const mutations = {
    SET_BARCODE_SETTINGS: (state, info) => {
        state.barcode_settings = [...info];
    }
};

const actions = {
    setBarcodeSettings({ commit }, info) {
        commit("SET_BARCODE_SETTINGS", info);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/barcode_settings.js